import axios from 'axios';
import { apiToken } from '~/services/api';
import { config } from '../../../../config';


// const auth = axios.create({ baseURL: config.API_AUTH });
const fiscal = axios.create({ baseURL: config.API_FISCAL });

async function setToken() {
	const responseApiToken = await apiToken.get('/');
	return responseApiToken.data.id_token;
}

async function getDirf(token, ec) {
	const uri = `/dirf/${ec}`;
	return fiscal.get(uri, {
		headers: { 'Content-Type': 'application/json', Authorization: token },
	});
}

const apiDift = {
	setToken,
	fiscal: {
		getDirf,
	},
};

export default apiDift;
